import React, { useEffect, useState } from 'react';
import { PanelBarGLPure, GridSelectionHLPure, DropDownBtnHLPure } from '../../pures';
import { Grid } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { normalizeDateForSorting } from '../../../utils'

const DocumentPanelBarBinnacle = (props) => {
    let {
        binnacle,
        setBinnacleSelected,
        actionOptions,
        type
    } = props

    const initialFilter = {
        logic: "and",
        filters: [],
    };

    const cellColumnOne = (props) => {
        return (
            <td className='documentPanelBarBinnacle-cell-one'>
                <span className="gridHLPure-userName">
                    {props.dataItem.date}
                </span>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return (
            <td className='documentPanelBarBinnacle-cell-two'>
                <span className="gridHLPure-fieldSubtitle">
                    {props.dataItem.nameUser}
                </span>
            </td>
        );
    };

    const cellColumnThree = (props) => {
        return (
            <td className='documentPanelBarBinnacle-cell-three'>
                <span className="gridHLPure-fieldSubtitle">
                    {props.dataItem.name}
                </span>
            </td>
        );
    };

    const [actionSelected, setActionSelected] = useState(0)

    const EventFilterCell = () => {
        return <div className="k-filtercell">
            <DropDownBtnHLPure
                optionsDropDown={actionOptions}
                onDropDownChange={(e) => setActionSelected(parseInt(e.target.value))}
                optionsValue={actionSelected}
                valueItem={"id"}
                nameOption={"name"}
            />
        </div>
    }

    const heightGrid = 'var(--binnacleHeight)'

    const initialSort = [
        {
            field: 'normalizedDate',
            dir: 'desc',
        },
    ];

    const { t } = useTranslation()

    const [dataGrid, setDataGrid] = useState(binnacle)
    const [filter, setFilter] = useState(initialFilter);
    const [customFilters, setCustomFilters] = useState([]);
    const [sort, setSort] = useState(initialSort);

    useEffect(() => {
        if (!binnacle || binnacle.length === 0) {
            setDataGrid([])
        }
    }, [binnacle])

    const onFilterGrid = (e) => {
        setFilter(e.filter)
    }

    useEffect(() => {
        let filters = []
        if (actionSelected !== 0) {
            filters.push({
                field: "documentActionId",
                operator: "eq",
                value: actionSelected,
            })
        }
        setCustomFilters(filters)
    }, [actionSelected]);

    useEffect(() => {
        if (!binnacle || binnacle.length === 0) return

        // Normalize dates for consistent sorting
        const normalizedBinnacle = binnacle.map(item => ({
            ...item,
            normalizedDate: normalizeDateForSorting(item.date)
        }))

        let completeFilter = {
            logic: "and",
            filters: [],
        }
        completeFilter.filters = filter ? filter.filters.concat(customFilters) : customFilters
        setDataGrid(orderBy(filterBy(normalizedBinnacle, completeFilter), sort))
    }, [filter, customFilters, sort, binnacle])

    const handleSortDate = (e) => {
        setSort(e.sort);
    }

    return (
        <div className='documentPanelBarBinnacle-container'>
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={t("documentPanelBarBinnacle.binnacle")}
                className='documentPanelBarBinnacle'
                id='documentPanelBarBinnacle'
            >
                <Grid item className={`documentPanelBarBinnacle-grid-documents ${type === process.env.REACT_APP_DIGITAL_VAULT_EXPEDIENTE ? 'documentPanelBarBinnacle-file-height' : '' }`}>
                    <GridSelectionHLPure
                        styleGeneral={true}
                        styleGeneralClass={"documentPanelBarBinnacle-general-grid"}
                        pageable={false}
                        skip={0}
                        take={dataGrid.length}
                        dataGrid={dataGrid}
                        sortable={true}
                        sort={sort}
                        onSortChange={(e) => handleSortDate(e)}
                        onSelectedItem={setBinnacleSelected}
                        columnTwo={true}
                        columnThree={true}
                        columnFive={false}
                        titleRow1={t("documentPanelBarBinnacle.date")}
                        titleRow2={t("documentPanelBarBinnacle.user")}
                        titleRow3={t("documentPanelBarBinnacle.actions")}
                        cellColumnOne={cellColumnOne}
                        cellColumnTwo={cellColumnTwo}
                        cellColumnThree={cellColumnThree}
                        styleGrid={{ height: heightGrid }}
                        filterable={true}
                        filter={filter}
                        onFilterChange={(e) => onFilterGrid(e)}
                        isCheckedColOne={'normalizedDate'}
                        fieldColumn2={'nameUser'}
                        fieldColumn3={'actions'}
                        filterableColumn1={false}
                        filterableColumn2={true}
                        filterableColumn3={true}
                        filterCellColumn3={EventFilterCell}
                        headerColumnThreeClass={"documentPanelBarBinnacle-header-cell-three"}
                        headerColumnTwoClass={"documentPanelBarBinnacle-header-cell-two"}
                        headerColumnOneClass={"documentPanelBarBinnacle-header-cell-one"}

                    />
                </Grid>
            </PanelBarGLPure>
        </div>
    )
}

export default DocumentPanelBarBinnacle